import { render, staticRenderFns } from "./Balance.vue?vue&type=template&id=209ba5b6&scoped=true&"
import script from "./Balance.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Balance.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Balance.vue?vue&type=style&index=0&id=209ba5b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209ba5b6",
  null
  
)

export default component.exports